import { METRIC_OPTIONS } from "@/types/reports/reports";
import type { EmbedPage } from "@/features/supabase";

/**
 * Datasets the org can open first, then alphabetically within each group, so the
 * usable ones are never buried under locked ones.
 */
export const sortDatasets = (datasets: EmbedPage[]): EmbedPage[] =>
  [...datasets].sort((a, b) => {
    if (a.can_open !== b.can_open) return a.can_open ? -1 : 1;
    return a.title.localeCompare(b.title);
  });

/**
 * The one-line blurb for a dataset, preferring the subtitle over the longer description.
 *
 * Both are declared non-null on the RPC return type -- that is just how Supabase types
 * `returns table` columns -- but the underlying `embed_pages` columns are nullable, so
 * they are accepted as nullable here.
 */
export const getDatasetBlurb = (dataset: {
  subtitle?: string | null;
  description?: string | null;
}): string => dataset.subtitle?.trim() || dataset.description?.trim() || "";

/** Human labels for the dataset's metric keys, ignoring any the Hub no longer knows about. */
export const getDatasetMetricLabels = (metrics: string[] | null | undefined): string[] =>
  (metrics ?? [])
    .map((metric) => METRIC_OPTIONS.find((option) => option.value === metric)?.label)
    .filter((label): label is string => !!label);
